import React from "react"
import { Cursor } from "../../elements"
import styled from "styled-components"

const ServicesCursor = ({ xValue, yValue }) => {
  return (
    <Services
      top={yValue}
      left={xValue}
      height="150"
      width="150"
      zIndex="999999"
    >
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 145 145">
        <path
          className="st1"
          d="M72.5,18.8C72.4,18.8,72.4,18.8,72.5,18.8c-4.1,0-7.7,1.9-10,4.9c-0.5,0.7-1.5,0.9-2.3,0.5
	c-1.8-0.9-3.7-1.4-5.7-1.4c-1.8,0-3.7,0.4-5.4,1.3c0,0,0,0,0,0c-3.7,1.8-6.1,5.1-6.8,8.8c-0.2,0.9-0.9,1.5-1.8,1.5
	c-0.1,0-0.2,0-0.3,0c-3.7,0-7.3,1.6-9.8,4.7c0,0,0,0,0,0c0,0,0,0,0,0c-2.5,3.2-3.2,7.2-2.3,10.8c0.2,0.9-0.2,1.7-1,2.1
	c-3.4,1.6-6.1,4.7-7,8.6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.9,4,0.2,7.9,2.7,10.8c0.6,0.7,0.6,1.6,0,2.3
	c-2.4,2.9-3.5,6.8-2.6,10.8c0,0,0,0.1,0,0.1c0.9,3.9,3.6,7,7.1,8.5c0.8,0.4,1.2,1.2,1,2.1c-0.9,3.7-0.1,7.7,2.4,10.8c0,0,0,0,0,0
	c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c2.5,3,6.1,4.6,9.7,4.6c0.2,0,0.3,0,0.5,0c0.9,0,1.6,0.6,1.8,1.4c0.8,3.7,3.2,7,6.9,8.7c0,0,0,0,0,0
	c0,0,0,0,0,0c1.7,0.8,3.5,1.2,5.3,1.2c2.1,0,4.1-0.5,5.9-1.5c0.7-0.4,1.6-0.2,2.2,0.5c2.3,3,5.9,4.9,9.9,4.9c0,0,0.1,0,0.1,0
	c0,0,0.1,0,0.1,0c4-0.1,7.6-2,9.8-5c0.5-0.7,1.5-0.9,2.3-0.5c1.7,0.9,3.6,1.3,5.6,1.3c1.9,0,3.8-0.4,5.6-1.3c0,0,0,0,0,0
	c0,0,0,0,0,0c3.6-1.8,6-5.2,6.7-8.9c0.2-0.9,0.9-1.5,1.8-1.5c0,0,0.1,0,0.1,0c3.7,0,7.4-1.7,9.9-4.8c0,0,0,0,0,0
	c2.5-3.2,3.2-7.2,2.2-10.9c-0.2-0.9,0.2-1.7,1-2.1c3.4-1.6,6-4.7,6.9-8.7c0,0,0,0,0,0c0,0,0,0,0,0c0.8-4-0.3-7.9-2.8-10.8
	c-0.6-0.7-0.6-1.6,0-2.3c2.4-2.9,3.4-6.9,2.4-10.8c0,0,0,0,0-0.1c0,0,0,0,0,0c-1-3.9-3.7-7-7.2-8.5c-0.8-0.4-1.3-1.2-1.1-2.1
	c0.8-3.7,0-7.7-2.5-10.8c0,0,0,0-0.1-0.1c-2.5-3-6-4.5-9.6-4.5c-0.2,0-0.4,0-0.6,0c-0.9,0-1.6-0.6-1.8-1.4c-0.8-3.7-3.3-6.9-7-8.6
	c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-1.7-0.8-3.4-1.1-5.2-1.1c-1.9,0-3.7,0.4-5.4,1.2c-0.8,0.4-1.6,0.2-2.2-0.5
	C79.7,20.5,76.3,18.8,72.5,18.8C72.5,18.8,72.5,18.8,72.5,18.8L72.5,18.8z"
        />
        <g>
          <path
            className="st0"
            d="M38.9,68c0-2.5,0.6-5.1,1.7-7.2c0.1-0.1,0.1-0.2,0.2-0.2H42c0.1,0,0.2,0.1,0.1,0.2c-0.7,2.2-1.1,4.8-1.1,7.2
		c0,2.5,0.4,5.1,1.1,7.2c0,0.1,0,0.2-0.1,0.2h-1.2c-0.1,0-0.2-0.1-0.2-0.2C39.5,73.1,38.9,70.5,38.9,68z"
          />
          <path
            className="st0"
            d="M45.1,61.9c0-0.1,0.1-0.2,0.2-0.2h2.3c0.1,0,0.2,0.1,0.3,0.2l2,7.7h0.1v-7.7c0-0.1,0.1-0.2,0.2-0.2h1.7
		c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-2.2c-0.1,0-0.2-0.1-0.3-0.2l-2.1-7.7h-0.1v7.7c0,0.1-0.1,0.2-0.2,0.2h-1.7
		c-0.1,0-0.2-0.1-0.2-0.2V61.9z"
          />
          <path
            className="st0"
            d="M55.1,72c-0.2-0.6-0.3-1.1-0.3-4.2c0-3.2,0.1-3.7,0.3-4.2c0.5-1.4,1.5-2.1,3.1-2.1s2.7,0.7,3.1,2.1
		c0.2,0.6,0.3,1.1,0.3,4.2c0,3.2-0.1,3.7-0.3,4.2c-0.5,1.3-1.5,2.1-3.1,2.1S55.6,73.4,55.1,72z M59.1,71.4c0.1-0.3,0.1-0.6,0.1-3.6
		s0-3.3-0.1-3.6c-0.1-0.3-0.4-0.6-0.9-0.6s-0.8,0.3-0.9,0.6c-0.1,0.3-0.1,0.6-0.1,3.6s0,3.3,0.1,3.6c0.1,0.3,0.4,0.6,0.9,0.6
		S59,71.7,59.1,71.4z"
          />
          <path
            className="st0"
            d="M66.1,74c-0.1,0-0.2-0.1-0.2-0.2v-9.8c0-0.1,0-0.1-0.1-0.1h-1.9c-0.1,0-0.2-0.1-0.2-0.2v-1.8
		c0-0.1,0.1-0.2,0.2-0.2h6.4c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.1,0-0.1,0.1v9.8c0,0.1-0.1,0.2-0.2,0.2
		H66.1z"
          />
          <path
            className="st0"
            d="M77.2,73l1.3-1.3c0.1-0.1,0.2-0.1,0.3,0c0.2,0.2,0.4,0.3,0.7,0.3c0.6,0,1-0.3,1-1.2v-8.9
		c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v8.7c0,2.5-1.3,3.5-3.3,3.5c-0.9,0-1.8-0.3-2.2-0.9C77.1,73.1,77.1,73,77.2,73z"
          />
          <path
            className="st0"
            d="M85.8,70.6v-8.8c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v9c0,0.6,0.3,1.1,0.9,1.1c0.6,0,1-0.4,1-1.1v-9
		c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v8.8c0,2.3-1.3,3.5-3.3,3.5C87,74.1,85.8,72.9,85.8,70.6z"
          />
          <path
            className="st0"
            d="M98.4,74.1c-2.2,0-3.3-1.2-3.3-3.3c0-0.1,0-0.2,0.1-0.2l1.9-0.3c0.1,0,0.2,0,0.2,0.1c0,1.1,0.4,1.6,1.1,1.6
		c0.7,0,1-0.3,1-1.5c0-1.1-0.2-1.5-1.1-1.8l-0.7-0.3c-1.7-0.7-2.3-1.6-2.3-3.5c0-2.2,1.1-3.4,3.2-3.4c2.1,0,3.2,1.1,3.2,3
		c0,0.1-0.1,0.2-0.2,0.2l-1.8,0.3c-0.1,0-0.2,0-0.2-0.1c0-0.9-0.3-1.3-1-1.3c-0.6,0-0.9,0.4-0.9,1.2c0,0.9,0.2,1.2,1.2,1.6l0.7,0.3
		c1.7,0.6,2.3,1.5,2.3,3.6C101.8,72.8,100.8,74.1,98.4,74.1z"
          />
          <path
            className="st0"
            d="M106.1,74c-0.1,0-0.2-0.1-0.2-0.2v-9.8c0-0.1,0-0.1-0.1-0.1h-1.9c-0.1,0-0.2-0.1-0.2-0.2v-1.8
		c0-0.1,0.1-0.2,0.2-0.2h6.4c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.1,0-0.1,0.1v9.8c0,0.1-0.1,0.2-0.2,0.2
		H106.1z"
          />
          <path
            className="st0"
            d="M46.6,91c-0.1,0-0.2-0.1-0.2-0.2v-9.8c0-0.1,0-0.1-0.1-0.1h-1.9c-0.1,0-0.2-0.1-0.2-0.2v-1.8
		c0-0.1,0.1-0.2,0.2-0.2h6.4c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.1,0-0.1,0.1v9.8c0,0.1-0.1,0.2-0.2,0.2
		H46.6z"
          />
          <path
            className="st0"
            d="M56.5,91.1c-2.2,0-3.3-1.2-3.3-3.3c0-0.1,0-0.2,0.1-0.2l1.9-0.3c0.1,0,0.2,0,0.2,0.1c0,1.1,0.4,1.6,1.1,1.6
		c0.7,0,1-0.3,1-1.5c0-1.1-0.2-1.5-1.1-1.8l-0.7-0.3c-1.7-0.7-2.3-1.6-2.3-3.5c0-2.2,1.1-3.4,3.2-3.4c2.1,0,3.2,1.1,3.2,3
		c0,0.1-0.1,0.2-0.2,0.2l-1.8,0.3c-0.1,0-0.2,0-0.2-0.1c0-0.9-0.3-1.3-1-1.3c-0.6,0-0.9,0.4-0.9,1.2c0,0.9,0.2,1.2,1.2,1.6l0.7,0.3
		c1.7,0.6,2.3,1.5,2.3,3.6C59.9,89.8,58.9,91.1,56.5,91.1z"
          />
          <path
            className="st0"
            d="M62.6,78.9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v4.6c0,0.1,0,0.1,0.1,0.1h1.7c0.1,0,0.1,0,0.1-0.1
		v-4.6c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2v-4.9
		c0-0.1,0-0.1-0.1-0.1H65c-0.1,0-0.1,0-0.1,0.1v4.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2V78.9z"
          />
          <path
            className="st0"
            d="M72.3,78.9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-2
		c-0.1,0-0.2-0.1-0.2-0.2V78.9z"
          />
          <path
            className="st0"
            d="M82.5,91c-0.1,0-0.2,0-0.2-0.1l-1.4-4.6h-0.7c-0.1,0-0.1,0-0.1,0.1v4.5c0,0.1-0.1,0.2-0.2,0.2h-2
		c-0.1,0-0.2-0.1-0.2-0.2V78.9c0-0.1,0.1-0.2,0.2-0.2h2.9c2.2,0,3.6,1,3.6,3.7c0,1.5-0.5,2.6-1.4,3.1l1.7,5.2c0,0.1,0,0.2-0.1,0.2
		H82.5z M82.1,82.5c0-1.3-0.4-1.7-1.3-1.7h-0.5c-0.1,0-0.1,0-0.1,0.1V84c0,0.1,0,0.1,0.1,0.1h0.5C81.7,84.1,82.1,83.8,82.1,82.5z"
          />
          <path
            className="st0"
            d="M89.1,91c-0.1,0-0.2-0.1-0.2-0.2v-9.8c0-0.1,0-0.1-0.1-0.1h-1.9c-0.1,0-0.2-0.1-0.2-0.2v-1.8
		c0-0.1,0.1-0.2,0.2-0.2h6.4c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.1,0-0.1,0.1v9.8c0,0.1-0.1,0.2-0.2,0.2
		H89.1z"
          />
          <path
            className="st0"
            d="M99,91.1c-2.2,0-3.3-1.2-3.3-3.3c0-0.1,0-0.2,0.1-0.2l1.9-0.3c0.1,0,0.2,0,0.2,0.1c0,1.1,0.4,1.6,1.1,1.6
		c0.7,0,1-0.3,1-1.5c0-1.1-0.2-1.5-1.1-1.8l-0.7-0.3c-1.7-0.7-2.3-1.6-2.3-3.5c0-2.2,1.1-3.4,3.2-3.4c2.1,0,3.2,1.1,3.2,3
		c0,0.1-0.1,0.2-0.2,0.2l-1.8,0.3c-0.1,0-0.2,0-0.2-0.1c0-0.9-0.3-1.3-1-1.3c-0.6,0-0.9,0.4-0.9,1.2c0,0.9,0.2,1.2,1.2,1.6l0.7,0.3
		c1.7,0.6,2.3,1.5,2.3,3.6C102.3,89.8,101.4,91.1,99,91.1z"
          />
          <path
            className="st0"
            d="M106,85c0-2.5-0.4-5.1-1.1-7.2c0-0.1,0-0.2,0.1-0.2h1.2c0.1,0,0.2,0.1,0.2,0.2c1.1,2.2,1.7,4.8,1.7,7.2
		c0,2.5-0.6,5.1-1.7,7.2c-0.1,0.1-0.1,0.2-0.2,0.2H105c-0.1,0-0.2-0.1-0.1-0.2C105.6,90.1,106,87.5,106,85z"
          />
        </g>
        <g>
          <path
            className="st11"
            d="M34.9,66c0-2.5,0.6-5.1,1.7-7.2c0.1-0.1,0.1-0.2,0.2-0.2H38c0.1,0,0.2,0.1,0.1,0.2c-0.7,2.2-1.1,4.8-1.1,7.2
		c0,2.5,0.4,5.1,1.1,7.2c0,0.1,0,0.2-0.1,0.2h-1.2c-0.1,0-0.2-0.1-0.2-0.2C35.5,71.1,34.9,68.5,34.9,66z"
          />
          <path
            className="st11"
            d="M41.1,59.9c0-0.1,0.1-0.2,0.2-0.2h2.3c0.1,0,0.2,0.1,0.3,0.2l2,7.7h0.1v-7.7c0-0.1,0.1-0.2,0.2-0.2h1.7
		c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-2.2c-0.1,0-0.2-0.1-0.3-0.2l-2.1-7.7h-0.1v7.7c0,0.1-0.1,0.2-0.2,0.2h-1.7
		c-0.1,0-0.2-0.1-0.2-0.2V59.9z"
          />
          <path
            className="st11"
            d="M51.1,70c-0.2-0.6-0.3-1.1-0.3-4.2c0-3.2,0.1-3.7,0.3-4.2c0.5-1.4,1.5-2.1,3.1-2.1s2.7,0.7,3.1,2.1
		c0.2,0.6,0.3,1.1,0.3,4.2c0,3.2-0.1,3.7-0.3,4.2c-0.5,1.3-1.5,2.1-3.1,2.1S51.6,71.4,51.1,70z M55.1,69.4c0.1-0.3,0.1-0.6,0.1-3.6
		s0-3.3-0.1-3.6c-0.1-0.3-0.4-0.6-0.9-0.6s-0.8,0.3-0.9,0.6c-0.1,0.3-0.1,0.6-0.1,3.6s0,3.3,0.1,3.6c0.1,0.3,0.4,0.6,0.9,0.6
		S55,69.7,55.1,69.4z"
          />
          <path
            className="st11"
            d="M62.1,72c-0.1,0-0.2-0.1-0.2-0.2v-9.8c0-0.1,0-0.1-0.1-0.1h-1.9c-0.1,0-0.2-0.1-0.2-0.2v-1.8
		c0-0.1,0.1-0.2,0.2-0.2h6.4c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.1,0-0.1,0.1v9.8c0,0.1-0.1,0.2-0.2,0.2
		H62.1z"
          />
          <path
            className="st11"
            d="M73.2,71l1.3-1.3c0.1-0.1,0.2-0.1,0.3,0c0.2,0.2,0.4,0.3,0.7,0.3c0.6,0,1-0.3,1-1.2v-8.9
		c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v8.7c0,2.5-1.3,3.5-3.3,3.5c-0.9,0-1.8-0.3-2.2-0.9C73.1,71.1,73.1,71,73.2,71z"
          />
          <path
            className="st11"
            d="M81.8,68.6v-8.8c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v9c0,0.6,0.3,1.1,0.9,1.1c0.6,0,1-0.4,1-1.1
		v-9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v8.8c0,2.3-1.3,3.5-3.3,3.5C83,72.1,81.8,70.9,81.8,68.6z"
          />
          <path
            className="st11"
            d="M94.4,72.1c-2.2,0-3.3-1.2-3.3-3.3c0-0.1,0-0.2,0.1-0.2l1.9-0.3c0.1,0,0.2,0,0.2,0.1c0,1.1,0.4,1.6,1.1,1.6
		c0.7,0,1-0.3,1-1.5c0-1.1-0.2-1.5-1.1-1.8l-0.7-0.3c-1.7-0.7-2.3-1.6-2.3-3.5c0-2.2,1.1-3.4,3.2-3.4c2.1,0,3.2,1.1,3.2,3
		c0,0.1-0.1,0.2-0.2,0.2l-1.8,0.3c-0.1,0-0.2,0-0.2-0.1c0-0.9-0.3-1.3-1-1.3c-0.6,0-0.9,0.4-0.9,1.2c0,0.9,0.2,1.2,1.2,1.6l0.7,0.3
		c1.7,0.6,2.3,1.5,2.3,3.6C97.8,70.8,96.8,72.1,94.4,72.1z"
          />
          <path
            className="st11"
            d="M102.1,72c-0.1,0-0.2-0.1-0.2-0.2v-9.8c0-0.1,0-0.1-0.1-0.1h-1.9c-0.1,0-0.2-0.1-0.2-0.2v-1.8
		c0-0.1,0.1-0.2,0.2-0.2h6.4c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.1,0-0.1,0.1v9.8c0,0.1-0.1,0.2-0.2,0.2
		H102.1z"
          />
          <path
            className="st11"
            d="M42.6,89c-0.1,0-0.2-0.1-0.2-0.2v-9.8c0-0.1,0-0.1-0.1-0.1h-1.9c-0.1,0-0.2-0.1-0.2-0.2v-1.8
		c0-0.1,0.1-0.2,0.2-0.2h6.4c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.1,0-0.1,0.1v9.8c0,0.1-0.1,0.2-0.2,0.2
		H42.6z"
          />
          <path
            className="st11"
            d="M52.5,89.1c-2.2,0-3.3-1.2-3.3-3.3c0-0.1,0-0.2,0.1-0.2l1.9-0.3c0.1,0,0.2,0,0.2,0.1c0,1.1,0.4,1.6,1.1,1.6
		c0.7,0,1-0.3,1-1.5c0-1.1-0.2-1.5-1.1-1.8l-0.7-0.3c-1.7-0.7-2.3-1.6-2.3-3.5c0-2.2,1.1-3.4,3.2-3.4c2.1,0,3.2,1.1,3.2,3
		c0,0.1-0.1,0.2-0.2,0.2l-1.8,0.3c-0.1,0-0.2,0-0.2-0.1c0-0.9-0.3-1.3-1-1.3c-0.6,0-0.9,0.4-0.9,1.2c0,0.9,0.2,1.2,1.2,1.6l0.7,0.3
		c1.7,0.6,2.3,1.5,2.3,3.6C55.9,87.8,54.9,89.1,52.5,89.1z"
          />
          <path
            className="st11"
            d="M58.6,76.9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v4.6c0,0.1,0,0.1,0.1,0.1h1.7c0.1,0,0.1,0,0.1-0.1
		v-4.6c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2v-4.9
		c0-0.1,0-0.1-0.1-0.1H61c-0.1,0-0.1,0-0.1,0.1v4.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2V76.9z"
          />
          <path
            className="st11"
            d="M68.3,76.9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-2
		c-0.1,0-0.2-0.1-0.2-0.2V76.9z"
          />
          <path
            className="st11"
            d="M78.5,89c-0.1,0-0.2,0-0.2-0.1l-1.4-4.6h-0.7c-0.1,0-0.1,0-0.1,0.1v4.5c0,0.1-0.1,0.2-0.2,0.2h-2
		c-0.1,0-0.2-0.1-0.2-0.2V76.9c0-0.1,0.1-0.2,0.2-0.2h2.9c2.2,0,3.6,1,3.6,3.7c0,1.5-0.5,2.6-1.4,3.1l1.7,5.2c0,0.1,0,0.2-0.1,0.2
		H78.5z M78.1,80.5c0-1.3-0.4-1.7-1.3-1.7h-0.5c-0.1,0-0.1,0-0.1,0.1V82c0,0.1,0,0.1,0.1,0.1h0.5C77.7,82.1,78.1,81.8,78.1,80.5z"
          />
          <path
            className="st11"
            d="M85.1,89c-0.1,0-0.2-0.1-0.2-0.2v-9.8c0-0.1,0-0.1-0.1-0.1h-1.9c-0.1,0-0.2-0.1-0.2-0.2v-1.8
		c0-0.1,0.1-0.2,0.2-0.2h6.4c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.1,0-0.1,0.1v9.8c0,0.1-0.1,0.2-0.2,0.2
		H85.1z"
          />
          <path
            className="st11"
            d="M95,89.1c-2.2,0-3.3-1.2-3.3-3.3c0-0.1,0-0.2,0.1-0.2l1.9-0.3c0.1,0,0.2,0,0.2,0.1c0,1.1,0.4,1.6,1.1,1.6
		c0.7,0,1-0.3,1-1.5c0-1.1-0.2-1.5-1.1-1.8l-0.7-0.3c-1.7-0.7-2.3-1.6-2.3-3.5c0-2.2,1.1-3.4,3.2-3.4c2.1,0,3.2,1.1,3.2,3
		c0,0.1-0.1,0.2-0.2,0.2l-1.8,0.3c-0.1,0-0.2,0-0.2-0.1c0-0.9-0.3-1.3-1-1.3c-0.6,0-0.9,0.4-0.9,1.2c0,0.9,0.2,1.2,1.2,1.6l0.7,0.3
		c1.7,0.6,2.3,1.5,2.3,3.6C98.3,87.8,97.4,89.1,95,89.1z"
          />
          <path
            className="st11"
            d="M102,83c0-2.5-0.4-5.1-1.1-7.2c0-0.1,0-0.2,0.1-0.2h1.2c0.1,0,0.2,0.1,0.2,0.2c1.1,2.2,1.7,4.8,1.7,7.2
		c0,2.5-0.6,5.1-1.7,7.2c-0.1,0.1-0.1,0.2-0.2,0.2H101c-0.1,0-0.2-0.1-0.1-0.2C101.6,88.1,102,85.5,102,83z"
          />
        </g>
        <g>
          <path
            className="st1"
            id="line_1"
            d="M111.9,27.3c-0.2,0-0.4,0-0.6-0.1c-0.9-0.3-1.3-1.3-0.9-2.2l4.3-10.6c0.3-0.9,1.3-1.3,2.2-0.9
		c0.9,0.3,1.3,1.3,0.9,2.2l-4.3,10.6C113.2,26.9,112.6,27.3,111.9,27.3z"
          />
        </g>
        <g>
          <path
            className="st1"
            id="line_2"
            d="M117.1,30.7c-0.4,0-0.7-0.1-1-0.3c-0.7-0.6-0.9-1.6-0.3-2.3l10.9-14.4c0.6-0.7,1.6-0.9,2.3-0.3
		s0.9,1.6,0.3,2.3l-10.9,14.4C118.1,30.5,117.6,30.7,117.1,30.7z"
          />
        </g>
        <g>
          <path
            className="st1"
            id="line_3"
            d="M121.8,35.7c-0.6,0-1.2-0.3-1.5-0.9c-0.4-0.8,0-1.8,0.8-2.2l9.4-4.5c0.8-0.4,1.8,0,2.2,0.8
		c0.4,0.8,0,1.8-0.8,2.2l-9.4,4.5C122.3,35.6,122.1,35.7,121.8,35.7z"
          />
        </g>
      </svg>
    </Services>
  )
}

export default ServicesCursor

const Services = styled(Cursor)`
  .st0 {
    fill: #eed36c;
  }
  .st1 {
    fill: #83c8b6;
  }
  .st2 {
    fill: #e14263;
  }
  .st3 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 1.5538;
    stroke-miterlimit: 10;
  }
  .st4 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 0.5614;
    stroke-miterlimit: 10;
  }
  .st5 {
    fill: #ffffff;
  }
  .st6 {
    fill: #c5934c;
  }
  .st7 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 1.5091;
    stroke-miterlimit: 10;
  }
  .st8 {
    fill: #0000ff;
  }
  .st9 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 0.5797;
    stroke-miterlimit: 10;
  }
  .st10 {
    fill: #e22651;
  }
  .st11 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 0.75;
    stroke-miterlimit: 10;
  }
  .st12 {
    fill: none;
    stroke: #db6780;
    stroke-width: 0.75;
    stroke-miterlimit: 10;
  }
  .st13 {
    fill: #e5a13d;
  }
  .st14 {
    fill: #0d2e33;
  }
  .st15 {
    fill: #b2c4aa;
  }
  .st16 {
    fill: none;
    stroke: #e92e55;
    stroke-width: 0.75;
    stroke-miterlimit: 10;
  }
  .st17 {
    fill: none;
    stroke: #e4af53;
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st18 {
    fill: none;
    stroke: #10363c;
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st19 {
    fill: none;
    stroke: #c4d1bf;
    stroke-width: 4;
    stroke-miterlimit: 10;
  }

  #line_1,
  #line_2,
  #line_3 {
    opacity: 0;
    animation: appear 0.3s infinite;
  }

  #line_1 {
    animation-delay: 0;
  }

  #line_2 {
    animation-delay: 0.05s;
  }
  #line_3 {
    animation-delay: 0.1s;
  }

  @keyframes appear {
    0% {
      opacity: 0;
    }
    70% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`
